import Navbar from "@/components/lumiere/Navbar";
import Footer from "@/components/lumiere/Footer";
import { Toaster } from "sonner";

export default function SiteLayout({ children, testId = "site-page" }) {
  return (
    <div data-testid={testId} className="bg-[#030812] text-white min-h-screen">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}
